import styled, { css, useTheme } from "styled-components";
import { NEW_LOOK_CONTENT_MAX } from "common/NewLook/tokens.ts";
import Flex from "common/Boxes/Flex";
import TopTraders from "features/newMarketplace/TopTraders";
import { sharedLib } from "@shared/services/shared.service";
import Groups from "features/newMarketplace/Groups";
import ScoreModal from "features/newMarketplace/common/ScoreModal";
import { useMemo, useState } from "react";
import { MarketplaceSubGroup } from "@shared/types";
import useMedia from "utils/hooks/useMedia";
import LoadingSpinnerOverlay from "common/Overlays/LoadingSpinnerOverlay";
import { PAGE_SPINNER_MARGIN_FROM_TOP } from "common/constants";
import { useBottomNavigator, useDisablePageScroll } from "utils/hooks/misc";
import { NEW_LOOK_SECTION_GAP } from "common/NewLook/layout.ts";

const Marketplace = () => {
  const theme = useTheme();
  const isSmallScreen = useMedia([`(max-width: 1300px)`], [true], false);
  const [scoreModalGroup, setScoreModalGroup] = useState<MarketplaceSubGroup>();
  const [showFullList, setShowFullList] = useState(false);
  const { isLoading } =
    sharedLib.sharedApi.marketplace.useGetMarketplaceInfoQuery();
  const { baseShouldDisplay: isBottomNavigator } = useBottomNavigator();
  useDisablePageScroll(isBottomNavigator);

  const mobileStyle = useMemo(() => {
    return isBottomNavigator ? { height: "100%" } : undefined;
  }, [isBottomNavigator]);

  return (
    <LoadingSpinnerOverlay
      isLoading={!theme.isNewLook && !isBottomNavigator && isLoading}
      spinnerMarginTop={PAGE_SPINNER_MARGIN_FROM_TOP}
      spinnerSize="large"
      hideContentWhileLoading={true}
      backgroundColor={theme.colors.layoutBgColor}
      wrapStyle={mobileStyle}
    >
      <Wrapper style={mobileStyle} $isBottomNavigator={isBottomNavigator}>
        {!isSmallScreen && (
          <TopTraders
            openScoreModal={setScoreModalGroup}
            showFullList={showFullList}
          />
        )}
        <GroupsWrapper
          $isSmallScreen={isSmallScreen}
          $isBottomNavigator={isBottomNavigator}
        >
          <Groups
            openScoreModal={setScoreModalGroup}
            showFullList={showFullList}
            setShowFullList={setShowFullList}
          />
        </GroupsWrapper>
        <ScoreModal
          group={scoreModalGroup}
          loading={isLoading}
          open={!!scoreModalGroup}
          closeModal={() => setScoreModalGroup(undefined)}
        />
      </Wrapper>
    </LoadingSpinnerOverlay>
  );
};

export default Marketplace;

const Wrapper = styled.div<{ $isBottomNavigator?: boolean }>`
  display: flex;
  flex-direction: column;
  ${(p) =>
    p.theme.isNewLook &&
    !p.$isBottomNavigator &&
    css`
      gap: ${NEW_LOOK_SECTION_GAP}px;
      width: 100%;
      max-width: ${NEW_LOOK_CONTENT_MAX + 64}px;
      margin: 0 auto;
      padding: 24px 32px 40px;
    `}
`;
const GroupsWrapper = styled.div<{
  $isSmallScreen?: boolean;
  $isBottomNavigator?: boolean;
}>`
  padding: 0 16px 16px;
  width: 100%;
  height: 100%;
  ${(p) =>
    p.$isSmallScreen &&
    `
    padding-top: 16px;
  `};
  ${(p) =>
    p.$isBottomNavigator &&
    `
      padding: 0;
    `}
  ${(p) =>
    p.theme.isNewLook &&
    !p.$isBottomNavigator &&
    `
      padding: 0;
    `}
`;
